// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Pagination_wrapper__32BFZ","form":"Pagination_form__IC-Es","pagination":"Pagination_pagination__12rx9"};